jQuery(function ($) {

  // global scripts

});
